const SafetyStockTableRow = ({row, actionComponent, checkBoxComponent}: any) => {
  return (
    <tr>
      {checkBoxComponent && <td>{checkBoxComponent(row)}</td>}
      <td>
        <div className='d-flex align-items-center py-2'>
          <div className='symbol symbol-40px me-3 border'>
            <img src={row.thumbnail_url} alt={row.product_name} />
          </div>
          <div className='d-flex flex-column'>
            <span>{row.product_name}</span>
          </div>
        </div>
      </td>
      <td>{row.child_sku}</td>
      <td>
        <div className='text-center'>{row.qty}</div>
      </td>
      <td>
        <div>{row.updated_by ?? '-'}</div>
      </td>
      {actionComponent && <td>{actionComponent(row)}</td>}
    </tr>
  )
}

export default SafetyStockTableRow
